export const dutyTypeList = "DUTY_TYPE_LIST";